import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import { urls } from '@/constants/urls';
import { useAuthStatus } from '@/hooks/use-auth-status';
import { UnauthenticatedLayout } from '../layouts/unauthenticated-layout';

export const AuthenticatedRouteWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const { isAuthenticated, cognitoAuthStatus } = useAuthStatus();

  return isAuthenticated ? (
    children
  ) : cognitoAuthStatus === 'unauthenticated' ? (
    <Navigate to={urls.login} />
  ) : (
    <UnauthenticatedLayout>
      <BeatLoader color="white" />
    </UnauthenticatedLayout>
  );
};
